import React from "react"
import MessageScreen from "components/SelfCheckin/MessageScreen/MessageScreen"
import { useTranslation } from 'react-i18next';
import whiteBurdMedium from "assets/images/whiteBurdMedium.png"

import './PassengerNotFound.scss'

export default function PassengerNotFound({airline, navigate}){
  const {t} = useTranslation();

  let text= t("INVALID BOARDING PASS");


  return (
      <MessageScreen airline={airline} message={text} mimg={whiteBurdMedium} />    
    )
}